
import type { Candidate } from '@/components/candidates/types';

/**
 * Converts database candidate data to our Candidate interface format
 * Handles type conversions, especially for JSONB fields like rejection_reasons
 */
export function convertDatabaseCandidateToCandidate(dbCandidate: any): Candidate {
  const converted: Candidate = {
    ...dbCandidate,
    // Convert rejection_reasons from Json to string array if needed
    rejection_reasons: convertJsonToStringArray(dbCandidate.rejection_reasons),
  };

  return converted;
}

/**
 * Converts Json type from database to string array
 * Handles various formats: string, string[], or null
 */
function convertJsonToStringArray(jsonValue: any): string[] | null {
  if (jsonValue === null || jsonValue === undefined) {
    return null;
  }
  
  // If it's already an array, return it
  if (Array.isArray(jsonValue)) {
    return jsonValue;
  }
  
  // If it's a string, try to parse it as JSON
  if (typeof jsonValue === 'string') {
    try {
      const parsed = JSON.parse(jsonValue);
      return Array.isArray(parsed) ? parsed : [jsonValue];
    } catch {
      // If parsing fails, treat it as a single item array
      return [jsonValue];
    }
  }
  
  // For any other type, convert to string and wrap in array
  return [String(jsonValue)];
}
